import api from './api'

export const fileService = {
  // Get files for SPK
  getFilesBySPK: async (spkId) => {
    const response = await api.get(`/files/spk/${spkId}`)
    return response.data
  },

  // Upload file - accepts FormData with spkId, fileType, schoolCode, pageCount, file
  upload: async (formData) => {
    const spkId = formData.get('spkId')
    const response = await api.post(`/files/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  // Validate file
  validate: async (fileId, validationData) => {
    const response = await api.put(`/files/${fileId}/validate`, validationData)
    return response.data
  },

  // Download file
  download: async (fileId) => {
    const response = await api.get(`/files/${fileId}/download`, {
      responseType: 'blob'
    })
    return response
  },

  // Delete file
  delete: async (fileId) => {
    const response = await api.delete(`/files/${fileId}`)
    return response.data
  },

  // Get QC templates
  getQCTemplates: async () => {
    const response = await api.get('/qc-templates')
    return response.data
  },

  // Get file recap (overview of all file slots)
  getRecap: async (params = {}) => {
    const response = await api.get('/files/recap', { params })
    return response.data
  },

  // Get pending review files (for reviewer)
  getPendingReview: async (params = {}) => {
    const response = await api.get('/files/review', { params })
    return response.data
  },

  // Get file version history
  getVersionHistory: async (fileId) => {
    const response = await api.get(`/files/${fileId}/versions`)
    return response.data
  }
}

export default fileService
